import { Category, DocumentInterestDTO, FeaturedPill, PillDocumentsDTO, Tutorial } from './../model/training.model';
import { Component, OnInit } from '@angular/core';
import { TrainingStore } from '../services/training.store';
import { AuthenticationService } from '@app/login';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LANGUAGE_CATALAN, LANGUAGE_SPANISH } from '@app/@core/constants/requests.constants';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { first, take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'scf-pills',
  templateUrl: './pills.component.html',
  styleUrls: ['./pills.component.scss'],
})
export class PillsComponent implements OnInit {
  documentList: PillDocumentsDTO[] = [];

  categoryList: Category[] = [];

  tutorialsList: Tutorial[] = [];

  featuredList: FeaturedPill[] = [];

  language: string;

  constructor(
    private trainingStore: TrainingStore,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.language = this.translateService.currentLang === LOCALE_ES ? LANGUAGE_SPANISH : LANGUAGE_CATALAN;

    this.translateService.onLangChange.subscribe((event) => {
      this.language = event.lang === LOCALE_ES ? LANGUAGE_SPANISH : LANGUAGE_CATALAN;
    });

    this.getNewsPills(this.translateService.currentLang === LOCALE_ES ? 'ES' : 'CA');

    this.translateService.onLangChange.subscribe((event) => {
      this.getNewsPills(event.lang === LOCALE_ES ? 'ES' : 'CA');
    });

    this.getCategoryPills(this.translateService.currentLang === LOCALE_ES ? 'ES' : 'CA');

    this.translateService.onLangChange.subscribe((event) => {
      this.getCategoryPills(event.lang === LOCALE_ES ? 'ES' : 'CA');
    });

    this.getDocumentsPills(this.translateService.currentLang === LOCALE_ES ? 'ES' : 'CA');

    this.translateService.onLangChange.subscribe((event) => {
      this.documentList = [];
      this.getDocumentsPills(event.lang === LOCALE_ES ? 'ES' : 'CA');
    });
  }

  getNewsPills(lang: string) {
    this.trainingStore
      .getFeatured(lang)
      .then(
        (data) => {
          data ? (this.featuredList = data) : console.error(data);
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  getDocumentsPills(lang: string) {
    this.trainingStore
      .getDocumentsPill(this.language)
      .then((data) => {
        data ? (this.documentList = data) : console.error(data);
      })
      .catch((error) => console.error(error));
  }

  getCategoryPills(lang: string) {
    this.trainingStore
      .getCategories(lang)
      .then((data) => {
        data ? (this.categoryList = data) : console.error(data);
      })
      .catch((error) => console.error(error));
  }
}
